// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1oLJr","author":"Table_author__205V4","authorImage":"Table_authorImage__2fgcB","unreadRow":"Table_unreadRow__3z2WF"};